import { cn } from "../../lib/utils";
import Spinner from "./spinner";

interface LoadingStateProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "preview";
  message?: string;
  fullScreen?: boolean;
}

const LoadingState = ({
  className,
  size = "md",
  variant = "default",
  message,
  fullScreen = false
}: LoadingStateProps) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center",
        fullScreen ? "min-h-screen" : "min-h-[200px]",
        className
      )}
    >
      <div className="flex flex-col items-center space-y-4">
        <Spinner size={size} variant={variant} />
        {message && (
          <span className="text-sm text-gray-600">{message}</span>
        )}
      </div>
    </div>
  );
};

export default LoadingState; 